import React, { useContext, useEffect } from 'react';

import { Box } from '@mui/material';
import { Redirect, Route, Switch } from 'react-router-dom';

import { Header } from '../../blocks/Header';
import { Loader } from '../../components/Loader';
import ProtectedRXDRoute from '../../components/ProtectedRXDRoute/ProtectedRXDRoute';
import { RXDContext } from '../../context/RXDContext';
import useScriptLoader, { SCRIPTS } from '../../context/ScriptLoader/useScriptLoader';
import { RXDLandingPage } from '../../pages/RXDLangingPage';
import { RXDTestPage } from '../../pages/RXDTestPage';
import { SingleVideoPage } from '../../pages/SingleVideoPage';
import { LearnerInfo, Tenant } from '../../types';
import getUserComUserId from '../../utils/helpers/getUserComUserId';
import useVerse from '../../utils/hooks/useVerse';
import useStyles from './styles';

interface RXDLayoutProps {
  tenant: Tenant;
  userInfo: LearnerInfo;
  userLoading: boolean;
}

const RXDLayout: React.FC<RXDLayoutProps> = ({ tenant, userInfo, userLoading }) => {
  const logoUrl = tenant?.logo_url;
  const classes = useStyles();

  const { rxdUserInfo } = useContext(RXDContext);
  const isUserComLoaded = useScriptLoader(SCRIPTS.USER_COM);
  const { changeUserId } = useVerse();

  useEffect(() => {
    if (rxdUserInfo || userInfo) {
      const userId = rxdUserInfo ? rxdUserInfo?.id : userInfo?.id;
      changeUserId(userId, rxdUserInfo ? '' : userInfo?.email || '', getUserComUserId(userId));
    }
  }, [userInfo, rxdUserInfo, changeUserId]);

  useEffect(() => {
    if (isUserComLoaded && window?.UE?.destroy) {
      window.UE.destroy();
    }
  }, [isUserComLoaded]);

  return (
    <>
      <Header onlyLogo={true} logoUrl={logoUrl} />
      <Box className={classes.root}>
        <Switch>
          <ProtectedRXDRoute
            exact
            path="/rxd/videos/:slug/"
            userInfo={userInfo}
            userLoading={userLoading}
            render={(props) => (
              <SingleVideoPage
                {...props}
                isXApiPage={true}
                fallback={<Loader />}
                bumperUrl={tenant?.video_bumper_url}
              />
            )}
          />
          <Route
            exact
            path="/rxd/landing"
            render={(props) => (
              <RXDLandingPage
                fallback={<Loader />}
                userInfo={userInfo}
                userLoading={userLoading}
                {...props}
              />
            )}
          />
          <Route
            exact
            path="/rxd/test"
            render={(props) => <RXDTestPage fallback={<Loader />} {...props} />}
          />
          <Redirect to="/" />
        </Switch>
      </Box>
    </>
  );
};

export default RXDLayout;
